import plasticVinylSrc from '@/assets/icons/plastic-vinyl.svg'
import { useToast } from '@/components/Toast'
import type { StepperLimit } from '@/components/ui/Stepper'
import { Stepper } from '@/components/ui/Stepper'
import {
  SEALED_VINYL_MAX_QUANTITY,
  SEALED_VINYL_MIN_QUANTITY,
  SEALED_VINYL_SHEETS_PER_PACK,
} from '@/pages/SealedVinylPage/lib/constants'

import {
  ProductCardContainer,
  ProductImage,
  ProductMeta,
  ProductName,
  ProductPrice,
  ProductRow,
  ProductStepperRow,
} from './styles'

interface ProductCardProps {
  quantity: number
  onQuantityChange: (next: number) => void
  /** 사용 컨텍스트 — 신청 화면(order) vs 수량 변경 화면(edit). 모서리 반경 차이만 있음 */
  context?: 'order' | 'edit'
}

export function ProductCard({ quantity, onQuantityChange, context = 'order' }: ProductCardProps) {
  const { show: showToast } = useToast()

  const handleLimitReached = (limit: StepperLimit) => {
    if (limit === 'max') {
      showToast(`최대 ${SEALED_VINYL_MAX_QUANTITY}개까지 가능해요`)
    }
  }

  return (
    <ProductCardContainer context={context}>
      <ProductRow>
        <ProductImage
          src={plasticVinylSrc}
          alt='밀봉비닐'
        />
        <ProductMeta>
          <ProductName>밀봉 비닐 (1개 당 {SEALED_VINYL_SHEETS_PER_PACK}장)</ProductName>
          <ProductPrice>무료</ProductPrice>
        </ProductMeta>
      </ProductRow>
      <ProductStepperRow>
        <Stepper
          value={quantity}
          onChange={onQuantityChange}
          min={SEALED_VINYL_MIN_QUANTITY}
          max={SEALED_VINYL_MAX_QUANTITY}
          onLimitReached={handleLimitReached}
        />
      </ProductStepperRow>
    </ProductCardContainer>
  )
}
